import { createContext, MouseEventHandler, useContext } from 'react';

import { ILatLng, TripTypeEnum, VehicleType } from '@mopla/data-models';

export interface ILegDetailsContext {
	mode: TripTypeEnum;
	vehicleType?: VehicleType;
	startPointLabel: string;
	startPointAddress?: string;
	startPointUrl?: string;
	startTime: string;
	endTime: string;
	effectiveStartTime: string | null;
	effectiveEndTime: string | null;
	endPointLabel: string;
	endPointAddress?: string;
	endPointUrl?: string;
	walkLegText: string | null;
	isStartEndDateFix: boolean;
	isTimeNarrow?: boolean;
	mapWaypoints: ILatLng[] | null;
	disabled?: boolean;
	showLiveMap?: boolean;
	onStartPointClick: MouseEventHandler;
	onEndPointClick: MouseEventHandler;
}

const legDetailsContext = createContext({} as ILegDetailsContext);

export const LegDetailsContextProvider = legDetailsContext.Provider;

export const useLegDetailsContext = () => useContext(legDetailsContext);
